import React,{useEffect,useState} from 'react';
import ReactDOM from 'react-dom/client';
import './assets/scss/styles.scss';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import store from './Store/store';
import { ToastContainer } from 'react-toastify';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'

const root = ReactDOM.createRoot( document.getElementById('root'));

root.render( 
    
    <Provider store={store}>
        <SkeletonTheme baseColor="#EEEEEE" highlightColor="#CECECE">
            
                <App/>
        
        </SkeletonTheme>
        <ToastContainer />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log("s"));
